module.exports = __webpack_public_path__ + "static/media/96x96.91f21afc.png";